var _InboxLink, _InboxWithNotificatio;
import InboxWithNotifications from "../../MainMenu/components/RightMenu/layout/RightMenuDesktop/components/InboxWithNotifications";
import InboxLink from "../../MainMenu/components/RightMenu/layout/RightMenuDesktop/components/InboxWithNotifications/InboxLink";
import { useMainMenuContext } from "../../MainMenu/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var RightMenu = function RightMenu() {
  var _useMainMenuContext = useMainMenuContext(),
    me = _useMainMenuContext.me,
    layoutConfig = _useMainMenuContext.layoutConfig,
    currentBreakpointKey = _useMainMenuContext.currentBreakpointKey;
  var shouldRenderInboxLink = me.hasInboxAccess && !layoutConfig.hideInboxLink && !me.isPremium || me.isMentor && !layoutConfig.hideInboxLink;
  if (!shouldRenderInboxLink || layoutConfig.hideEveryRightMenuAction) {
    return null;
  }
  if (currentBreakpointKey === 'xs') {
    return _InboxLink || (_InboxLink = /*#__PURE__*/_jsx(InboxLink, {}));
  }
  return _InboxWithNotificatio || (_InboxWithNotificatio = /*#__PURE__*/_jsx(InboxWithNotifications, {}));
};
export default RightMenu;